import BrowserCompatability from "../../helper/compatability/browserCompatability";
import VersionCompatability from "../../helper/compatability/versionCompatability";
import DateTimeParser from "../../helper/dateTimeParser";

export default {
    browsers: new BrowserCompatability(true, null, null),
    versions: new VersionCompatability(true, false),

    parseLegends: ($) => {
        const spanElement = $.find('#servertime span.timer')[0];
        // value attribute doesn't update, so we use a small hack to get around it.
        const valueAtPageLoad = spanElement.getAttribute('value');
        const currentTime = spanElement.innerHTML;
        const currentTimeAsTimestamp = DateTimeParser.parseTimeHHMMSS(currentTime);
        const fullHoursBetweenTimestamps = Math.floor((currentTimeAsTimestamp - valueAtPageLoad) / 3600);
        return currentTimeAsTimestamp + fullHoursBetweenTimestamps * 3600;
    },

    parseKingdoms: () => {

    }
};
